import { IGameState } from '../IGameState';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'typesafe-actions';
import Game from '../../../Game';
import { AuthPlatform, Native, PlatformErrorCode } from '@softgames/mobile-dev-tools';
import { PlatformActions } from '../PlatformActions';
import { DataConflictActions } from '../DataConflictActions';
import { SignInState } from '../SignInState';
import { trackUserUnification } from 'Utility/Tracking/TrackingHelpers/User';

/**
 * Trigger sign in on platform.
 */

export function signIn(
    platform: AuthPlatform,
    silently: boolean = false,
    reward: boolean = false
): ThunkAction<Promise<void>, IGameState, never, Action> {
    return async dispatch => {
        PlatformActions.setSignInState(SignInState.InProgress);
        try {
            const { success, errorCode } = await Game.sdk.signIn(platform, silently);
            if (!success) {
                if (silently) {
                    PlatformActions.signInSilentFail();
                } else {
                    PlatformActions.signInFail(errorCode);
                }
                return;
            }
            const state = Game.store.getState();
            if (platform === AuthPlatform.Facebook) {
                // Check to send userUnification tracking
                // Only sent once when signed in via Facebook
                if(!state.playerState.isFbInstantUnified){
                    trackUserUnification(state, Native.main.getDeviceId() || state.playerState.deviceId, state.playerState.facebookUserId || Game.sdk.getUserId());
                    PlatformActions.setFacebookUnified();
                }
                // If sign into Facebook is from the Saga Map reward the player.
                if(reward) {
                    PlatformActions.setSignInFacebookReward();
                }
            }
            PlatformActions.signInSuccess();
            // Fetch for data conflicts after signing in
            dispatch(DataConflictActions.fetchConflicts());
        } catch (e) {
            PlatformActions.setSignInState(SignInState.SignedOut);
        }
    };
}

/**
 * Trigger sign out of platform.
 */
export function signOutFirebase(): ThunkAction<Promise<void>, IGameState, never, Action> {
    return async () => {
        PlatformActions.setSignInState(SignInState.InProgress);
        try {
            await Game.sdk.signOut();
            PlatformActions.setSignInState(SignInState.SignedOut);
        } catch (e) {
            PlatformActions.setSignInState(SignInState.SignedIn);
        }
    };
}

export interface IAuthReturnValues {
    success: boolean;
    appScopedId: string;
    token: string;
    errorCode: PlatformErrorCode;
}
